/**
 * 获取数据类型
 * @param {Any} tar
 * @returns {String}
 * @description
 * '[object Number]'
 * '[object String]'
 * '[object Boolean]'
 * '[object Object]'
 * '[object Undefined]'
 * '[object Null]'
 * '[object Array]'
 * '[object Date]'
 * '[object Function]'
 * '[object Number]'
 * '[object Event]'
 * '[object File]'
 * '[object Set]'
 * '[object Map]'
 */
export function getType(tar) {
  return Object.prototype.toString.call(tar);
}

export function isString(tar) {
  return getType(tar) === "[object String]";
}

export function isBoolean(tar) {
  return getType(tar) === "[object Boolean]";
}

export function isNumber(tar) {
  return getType(tar) === "[object Number]";
}

export function isArray(tar) {
  return getType(tar) === "[object Array]";
}

export function isObject(tar) {
  return getType(tar) === "[object Object]";
}

export function isError(tar) {
  return getType(tar) === "[object Error]";
}

export function isFunction(tar) {
  return getType(tar) === "[object Function]";
}

export function isNull(tar) {
  return getType(tar) === "[object Null]";
}

export function isUndefined(tar) {
  return getType(tar) === "[object Undefined]";
}

export function isDate(tar) {
  return getType(tar) === "[object Date]";
}

/**
 * 判断目标是否为空
 * @param {Any} tar
 * @returns {Boolean} Boolean
 * @description
 * 0 -> true
 * '' -> true
 * '0' -> false
 * () -> true
 * null -> true
 * [] -> true
 * {} -> true
 * undefined -> true
 */
export function isEmpty(tar) {
  var type = Object.prototype.toString.call(tar);
  switch (type) {
    case "[object Number]":
    case "[object Boolean]":
      return false;
    case "[object Object]":
      return !Object.keys(tar).length;
    case "[object String]":
    case "[object Array]":
      return !tar.length;
    case "[object File]":
    case "[object Map]":
    case "[object Set]":
      return !tar.size;
    case "[object Error]":
      return tar.message === "";
    default:
      return !tar;
  }
}

export function notEmpty(tar) {
  return !isEmpty(tar);
}
